import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { ProductId } from 'services/products/types';
import { createStructuredSelector } from 'reselect';
import { SprayWaterRate } from 'services/sprayEvents/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectProductWaterRate } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: ProductId;
}

interface ConnectedProps {
    productWaterRate: SprayWaterRate;
}

type Props = OwnProps & ConnectedProps;

export class ProductWaterRateTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { productWaterRate } = this.props;

        return <TableCell>{productWaterRate}L</TableCell>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    productWaterRate: makeSelectProductWaterRate()
});

export default connect(mapStateToProps)(ProductWaterRateTableCellComponent);
